import { KeyboardArrowRight } from '@mui/icons-material';
import {
	Stack, Typography, Box, useTheme, styled, Collapse,
	Link,
	useMediaQuery,
} from '@mui/material';
import Dimens from 'assets/dimens';
import {
	ajNatalBanner, ajNatalMobile, robot, socialMedia,
} from 'assets/images';
// import { recBanner, recBannerPhone } from 'assets/images/campaigns';
import { ajtec } from 'assets/images/icons';
import {
	ActionButtons,
	BodyText,
	DefaultButton, Space, SubTitle, TitleLarge,
} from 'common/presentation/components';
import ContactDialog from 'common/presentation/components/contact-dialog/ContactDialog';
import SizedBox from 'common/presentation/components/sized-box/SizedBox';
import useEffectCustom from 'common/presentation/hooks/useEffectCustom';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';
import { TransitionGroup } from 'react-transition-group';
import RecommendModal from './components/RecommendModal';

const HeroSection = () => {
	const theme = useTheme();
	const { t } = useTranslation('translations');
	const [textArray] = useState([t('management'), t('web'), t('mobile'), t('infrastructure')]);
	const [activeIndex, setActiveIndex] = useState(0);
	const [reqDemo, setReqDemo] = useState(false);
	const [recommendModal, setRecommendModal] = useState(false);
	const isMd = useMediaQuery(theme.breakpoints.up('md'));
	// const [image, setImage] = useState(recBanner);
	const [image, setImage] = useState(ajNatalBanner);

	// useEffectCustom(() => {
	// 	if (isMd) {
	// 		setImage(recBanner);
	// 	} else {
	// 		setImage(recBannerPhone);
	// 	}
	// }, [isMd]);
	useEffectCustom(() => {
		if (isMd) {
			setImage(ajNatalBanner);
		} else {
			setImage(ajNatalMobile);
		}
	}, [isMd]);

	const SocialMediaText = styled(Typography)(() => ({
		fontSize: Dimens.TEXT_SMALL,
		color: theme.palette.textLight.main,
		fontWeight: Dimens.TEXT_WEIGHT_LIGHT,
		'&:hover': {
			cursor: 'pointer',
		},
	}));

	useEffectCustom(() => {
		const interval = setInterval(() => {
			setActiveIndex((prev) => {
				let mPrev = prev;
				if (mPrev !== textArray.length - 1) {
					mPrev += 1;
					return mPrev;
				}
				return 0;
			});
		}, 1500);
		return () => clearInterval(interval);
	}, []);

	const handleRequstDemoClick = () => {
		setReqDemo(true);
	};

	// const handleRecommentClick = () => {
	// 	setRecommendModal(true);
	// };

	return (
		<section>
			<Box
				sx={{
					pl: { md: Dimens.APP_BAR_PADDING, xs: 2 },
					pr: { md: 0, xs: 2 },
				}}
			>
				<ActionButtons icon={ajtec} />
			</Box>
			<Box
				sx={{
					height: 'auto',
					backgroundImage: `url(${image})`,
					backgroundSize: 'cover',
					backgroundPosition: 'center',
					mt: { md: 6, xs: 0 },
					mb: { xs: 3, md: 0 },
					position: 'relative',
				}}
			>
				<img src={image} alt="Banner" style={{ width: '100%', height: 'auto', display: 'block' }} />
				{/* <img src={image} alt="Banner"
				style={{ width: '100%', height: 'auto', display: 'block' }} /> */}
				{/* <Box
					sx={{
						position: 'absolute',
						bottom: { xs: '5%', md: '5%' },
						top: { md: 'auto', xs: 'auto' },
						left: { md: '12%', xs: '50%' },
						transform: 'translate(-50%, 0)',
						...(isMd && { transform: 'translate(-50%, -50%)' }),
					}}
				>
					<DefaultButton
						color="primary"
						sx={{
							color: theme.palette.background.default,
							pl: { md: '48px', xs: '18px' },
							pr: { md: '48px', xs: '18px' },
							fontSize: { md: Dimens.TEXT_MEDIUM, xs: Dimens.TEXT_SMALL },
							animation: 'pulse 2s infinite',
							'&:hover': {
								animationPlayState: 'paused',
							},
							'@keyframes pulse': {
								'0%': {
									transform: 'scale(1)',
									boxShadow: `0 0 0 0 ${theme.palette.primary.main}40`,
								},
								'70%': {
									transform: 'scale(1.09)',
									boxShadow: `0 0 0 10px ${theme.palette.primary.main}00`,
								},
								'100%': {
									transform: 'scale(1)',
									boxShadow: `0 0 0 0 ${theme.palette.primary.main}00`,
								},
							},
						}}
						onClick={handleRecommentClick}
					>
						{t('recommend')}
					</DefaultButton>
				</Box> */}
			</Box>
			<Box sx={{ pl: { md: Dimens.APP_BAR_PADDING, xs: 2 }, pr: { md: 0, xs: 2 } }}>
				<Stack direction="row" sx={{ mt: { xs: 0, md: theme.spacing(7) } }}>
					<Box sx={{ width: { md: '40%', xs: '100%' } }}>
						<TitleLarge>
							{t('welcome_message')}
						</TitleLarge>
						<SizedBox height={4} />
						<Stack direction="row">
							<SubTitle sx={{ color: theme.palette.success.main }}>
								{t('web_solutions')}
							</SubTitle>
							<TransitionGroup>
								<Collapse key={activeIndex}>
									<SubTitle sx={{ color: theme.palette.success.main, ml: 1 }}>
										{textArray[activeIndex]}
									</SubTitle>
								</Collapse>
							</TransitionGroup>
						</Stack>
						<SizedBox height={4} />
						<BodyText>
							{t('welcome_message_description')}
						</BodyText>
						<SizedBox height={4} />
						<DefaultButton onClick={handleRequstDemoClick} endIcon={<KeyboardArrowRight />}>{t('request_demo')}</DefaultButton>
						<SizedBox height={4} />
						<Stack direction="row" alignItems="center" display={{ md: 'flex', xs: 'none' }}>
							<img src={socialMedia} alt="social media icon" />
							<Space width={Dimens.XS_SPACING} />
							<Typography sx={{
								fontWeight: Dimens.TEXT_WEIGHT_BOLD,
								fontSize: Dimens.TEXT_DEFAULT,
								color: theme.palette.textMain.main,
							}}
							>
								{t('follow_us')}
							</Typography>
						</Stack>
						<Stack direction="row" sx={{ pl: 9 }} display={{ md: 'flex', xs: 'none' }}>
							<Link to="https://pt.linkedin.com/company/ajtec" target="_blank" component={RouterLink} color="inherit" underline="none">
								<SocialMediaText>Linked in</SocialMediaText>
							</Link>
							<Space width={Dimens.XS_SPACING} />
							<Link to="https://www.instagram.com/ajtec.pt/" target="_blank" component={RouterLink} color="inherit" underline="none">
								<SocialMediaText>Instagram</SocialMediaText>
							</Link>
							{/* <Space width={Dimens.XS_SPACING} />
							<SocialMediaText>Facebook</SocialMediaText> */}
						</Stack>
					</Box>
					<Box sx={{
						display: { md: 'flex', xs: 'none' },
						flexDirection: 'column',
						alignItems: 'center',
						justifyContent: 'flex-end',
						width: { md: '60%' },
						backgroundImage: `linear-gradient(to bottom right, ${theme.palette.background.default} 45%, rgba(103,226,194,0.5) 75%, rgba(180,255,153,0.2) 100%)`,

					}}
					>
						<img src={robot} alt="Robot" width="65%" height="95%" />
					</Box>
				</Stack>
			</Box>
			<ContactDialog open={reqDemo} handleClose={() => setReqDemo(false)} />
			<RecommendModal open={recommendModal} handleClose={() => setRecommendModal(false)} />
		</section>
	);
};

export default HeroSection;
